import cryptoJS from 'crypto-js';

export default function getEncrypted(string) {
    return string ? cryptoJS.SHA256(string).toString() : '';
}
